import { Controller } from '@hotwired/stimulus';
import { loadFlag, saveFlag } from '../storage_flag';

// <details> の開閉状態を localStorage に永続化する。
// 現在ページがサブメニュー内にある場合は HAML 側で `open` 属性が付くため、
// ここでは触らずに HAML の判定を優先する。
export default class extends Controller {
  static values = { storageKey: String };

  connect() {
    if (!this.element.open && loadFlag(this.storageKeyValue)) {
      this.element.open = true;
    }
    this.element.addEventListener('toggle', this.onToggle);
  }

  disconnect() {
    this.element.removeEventListener('toggle', this.onToggle);
  }

  onToggle = () => {
    saveFlag(this.storageKeyValue, this.element.open);
  };
}
